export default __webpack_public_path__ + "static/resume-771d864f8d7d47a385c991a1ccb5d6eb.pdf";